export default __webpack_public_path__ + "static/media/mappin_green.17c6d87b.svg";